import { Component, OnInit } from '@angular/core';

@Component({
  selector: '[class="celerity-app"]',
  templateUrl: './server-down.component.html',
  styleUrls: ['./server-down.component.scss']
})
export class ServerDownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
